let en = {
  Title: "Protocol",
  Subtitle: "A standard protocol family for connecting and extending blockchain boundaries.",
  Content: [
    {name: 'Seal brigade', desc: 'Seal cross-chain smart contract standard protocol. Allows users to invoke smart contracts deployed on different blockchains through a unified interface.'},
    {name: 'Seal blockchain', desc: 'Seal blockchain standard protocol. Allows users to deploy and run blockchains without coding.'},
    {name: 'Seal gateway', desc: 'Seal cross-chain gateway protocol. Allow users to focus on their business without having to care about the implementation of the blockchain.'},
  ],
}

let zh = {
  Title: 'Protocol',
  Subtitle: '连接和扩展区块链边界的标准协议族。',
  Content: [
    {name: '智能合约桥', desc: 'Seal跨链智能合约标准协议。 让使用者可以通过统一的接口调用部署在不同区块链上的智能合约。'},
    {name: 'Seal链', desc: 'Seal区块链标准协议。让使用者可以在无需编码的情况下，进行区块链的部署和运行。'},
    {name: 'Seal网关', desc: 'Seal跨链协议。让使用者可以专注于他们的业务，而无需关心区块链的实现。'},
  ],
}

let name = 'Tech'

export default {
  name,
  en,
  zh
}